import { getLabsOnHomeSummary } from 'aster-foundation/core/teleconsultant/records/redux/actions';
import PropTypes from 'prop-types';
import moment from 'moment';
import { useEffect, useState, useMemo } from 'react';
import { Container } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { errorHandling } from '../../Common/Utility/common-utils';
import HomePageCard from './HomePageCard';
import LabTestHomeStyled from './LabTestHomeStyled';
import useGetReportCount from './Hook/useGetReportCount';
import { labReportView } from './LabReportAnalytics';

const LabTestHome = ({ customClass }) => {
  const dispatch = useDispatch();
  const userLogin = useSelector((state) => state?.astercore?.checkUserExist?.data?.entry?.[0]?.resource);
  const [labReportSummary, setLabReportSummary] = useState([]);
  const { total, completed, inProgress, totalViewCount, totalAppointments } = useGetReportCount(labReportSummary);

  const memoisedReport = useMemo(() => labReportSummary, [labReportSummary]);
  const memoisedLogin = useMemo(() => userLogin, [userLogin]);

  const sortByAppointmentDate = useMemo(() => (labReports) => {
    const sortedReports = labReports
      .map((patient) => ({
        ...patient,
        appointments: patient?.appointments
          ?.filter((apt) => !apt?.labResults?.summary?.isLabReportsViewed)
          ?.sort((a, b) => moment(b?.appointmentDate, 'DD/MM/YYYY') - moment(a?.appointmentDate, 'DD/MM/YYYY')),
      }))
      .filter((appointment) => appointment?.appointments?.length > 0);
    setLabReportSummary(sortedReports);
  }, []);

  useEffect(() => {
    if (memoisedLogin?.id) {
      const reqParams = { patientId: memoisedLogin?.id };
      dispatch(
        getLabsOnHomeSummary({
          reqParams,
          onSuccess: ({ body }) => {
            if (body?.length > 0) {
              sortByAppointmentDate(body);
            }
          },
          onFailure: errorHandling,
        }),
      );
    }
  }, [dispatch, memoisedLogin, sortByAppointmentDate]);

  useEffect(() => {
    if (memoisedReport?.length !== 0) {
      labReportView(memoisedReport);
    }
  }, [memoisedReport]);

  if (memoisedReport?.length === 0 || totalAppointments === totalViewCount) {
    return null;
  }

  return (
    <LabTestHomeStyled>
      <Container className={customClass}>
        <HomePageCard report={memoisedReport} total={total} completed={completed} inProgress={inProgress} />
      </Container>
    </LabTestHomeStyled>
  );
};

LabTestHome.propTypes = {
  customClass: PropTypes.string,
};

LabTestHome.defaultProps = {
  customClass: '',
};

export default LabTestHome;
